import React from 'react';

import { BackDropCustom, SnackBarCustom } from '../Components/shared/ReusableSmallComponents';
import useUtilities from '../hooks/useUtilities';

function PlateFormeUtilitiesComponent() {
    const { backdropOpen, setBackdropOpen,openSnackBar, setOpenSnackBar, snackBarMessage, isSnackBarError } = useUtilities();
    return (
        <>
            <BackDropCustom
                backdropOpen={backdropOpen}
                setBackdropOpen={setBackdropOpen}
            />
            <SnackBarCustom
            //! always setMessage before opening the snackBar, to have a message displayed !!
                snackBarMessage={snackBarMessage}
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
                isSnackBarError={isSnackBarError}
            />
        </>
    );
}

export default PlateFormeUtilitiesComponent;